import {
  BaseServiceStateGenerator
} from "@pages/AdditionalServices/containers/services/serviceStateGenerator/baseServiceStateGenerator";
import {
  VerticalTableTemplateProcessor
} from "@pages/AdditionalServices/containers/services/serviceStateGenerator/verticalTableTemplateProcessor";
import { CustomsPaymentsTemplateProcessor } from "./customsPaymentsTemplateProcessor";

// Фабрика сервиса
const serviceStateGenerator = () => new BaseServiceStateGenerator([
  new VerticalTableTemplateProcessor,
  new CustomsPaymentsTemplateProcessor,
])

export default serviceStateGenerator;
